import InfoBox from 'components/InfoBox';
import styled from 'styled-components';

const StyledEmptyState = styled.div`
  margin-top: 4rem;
  display: flex;
  justify-content: center;
`;

const EmptyState = () => {
  return (
    <StyledEmptyState>
      <InfoBox
        width='auto'
        iconAlign='center'
        padding='x-small'
        mt='none'
        iconColor='azureRadius'
        backgroundColor='solitude'
      >
        No data to present. <br />
        Enter your personal access token on the right.
      </InfoBox>
    </StyledEmptyState>
  );
};

export default EmptyState;
